import React, { useState } from 'react';

import { sanitize } from 'lib/helpers/sanitize';
import { cn } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import { formatLabel } from 'components/shared/ExpandableToolbar/lib/helpers';

import { formatChangedValues } from '../lib/formatChangedValues';

const MAX_VISIBLE_ITEMS = 2;

const ActivityContent = ({
  isChild = false,
  formattedChanges = [],
  action,
  showOnlyNewValue = false
}) => {
  const [showAll, setShowAll] = useState(false);

  const hasMoreItems = formattedChanges.length > MAX_VISIBLE_ITEMS;
  const visibleChanges =
    showAll || !hasMoreItems ? formattedChanges : formattedChanges.slice(0, MAX_VISIBLE_ITEMS);

  return (
    <div
      className={cn(
        'flex flex-1 flex-col gap-2',
        !isChild && 'ml-[9px]',
        'border-b-0 border-l-[1px] border-r-0 border-t-0 border-solid border-neutral-300 pl-[13px]'
      )}>
      {visibleChanges.map((item) => {
        const { key, isNestedKey, prevValueRaw, currValueRaw, prevValue, currValue } = item;

        const itemClassName = 'flex flex-wrap items-center gap-1 text-sm leading-[22px]';

        return (
          <div key={key} className={itemClassName}>
            <span className="font-semibold text-neutral-800">{formatLabel(key)}</span>

            {isNestedKey ? (
              <ActivityContent
                key={key}
                isChild
                action={action}
                formattedChanges={
                  formatChangedValues({
                    activities: [{ previousValues: prevValueRaw, currentValues: currValueRaw }]
                  })[0]?.formattedChanges || []
                }
              />
            ) : (
              <>
                {!showOnlyNewValue && (
                  <>
                    <span className="font-500 text-neutral-500">from</span>
                    <span
                      className="font-500 text-neutral-500"
                      dangerouslySetInnerHTML={sanitize(prevValue)}
                    />
                    <span className="font-500 text-neutral-500">to</span>
                  </>
                )}

                <span
                  className="font-semibold text-neutral-800"
                  dangerouslySetInnerHTML={sanitize(currValue)}
                />
              </>
            )}
          </div>
        );
      })}

      {hasMoreItems && (
        <Button
          size="xs"
          variant="link"
          text={`Show ${showAll ? 'less' : 'all...'}`}
          textClassName="text-xs"
          onClick={() => setShowAll((prev) => !prev)}
        />
      )}
    </div>
  );
};

export default ActivityContent;
